// src/components/HeroSection.js
import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const HERO_PHOTOS_FILES = [
  "photo10.jpg",
  "photo14.jpg",
  "photo12.jpg",
  "photo13.jpg",
];

const HeroSection = ({ title, subtitle }) => {
  const heroImages = useMemo(() => {
    return HERO_PHOTOS_FILES.map((f) => `/photos/photos/${f}`);
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);

  useEffect(() => {
    if (!heroImages.length) return;

    const interval = setInterval(() => {
      setPrevIndex(currentIndex);
      setCurrentIndex((prev) => (prev + 1) % heroImages.length);
    }, 15000);

    return () => clearInterval(interval);
  }, [currentIndex, heroImages]);

  const currentSrc = heroImages[currentIndex] || "";
  const prevSrc = prevIndex !== null ? heroImages[prevIndex] : null;

  return (
    <section className="relative h-[34vh] md:h-[40vh] lg:h-[42vh] overflow-hidden flex items-center justify-center">
      {prevSrc && (
        <motion.div
          key={`prev-${prevIndex}`}
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${prevSrc})` }}
        />
      )}

      <motion.div
        key={`current-${currentIndex}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${currentSrc})` }}
      />

      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/55" />

      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1 }}
        className="relative z-10 text-center px-6"
      >
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-normal tracking-tight text-white drop-shadow-[0_4px_30px_rgba(0,0,0,0.7)]">
          {title}
        </h1>

        <p className="mt-4 text-sm sm:text-base md:text-lg tracking-[0.22em] uppercase font-light text-white/95 max-w-2xl mx-auto">
          {subtitle}
        </p>

        {/* CTA Section */}
        {/* CTA Section */}
<div className="mt-8 flex justify-center">
  <Link
    to="/contact"
    className="
      px-8 py-3
      rounded-full
      text-sm tracking-widest uppercase
      bg-white/10
      border border-white/30
      text-white
      backdrop-blur-md
      transition-all duration-300
      hover:bg-white/20
      hover:border-white/60
      hover:shadow-[0_8px_40px_rgba(0,0,0,0.35)]
    "
  >
    Book a Session
  </Link>
</div>
      </motion.div>
    </section>
  );
};

export default HeroSection;